import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  align: {
    paddingTop: '9px !important',
  },
  required: {
    '&::after': {
      content: '"*"',
      color: 'red',
      marginLeft: '4px',
    },
  },
  countrySelector: ({ isDownsized }) => ({
    position: 'relative',
    '& .react-tel-input': {
      position: 'static !important',
    },
    '& .flag-dropdown': {
      top: '25px !important',
      bottom: '10px !important',
      background: 'none !important',
    },
    '& .open-dropdown': {
      width: '100% !important',
    },
    '& .country-list': {
      position: 'absolute !important',
      width: 'calc(100% - 16px) !important',
      margin: '0 !important',
      height: isDownsized ? '240px !important' : '280px !important',
    },
    '& .MuiInputLabel-root': {
      transform: 'translate(50px, 22px)',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(0, 0) scale(0.75)',
    },
  }),
});
